import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-template-dialog',
  templateUrl: './select-template-dialog.component.html',
  styleUrls: ['./select-template-dialog.component.css']
})
export class SelectTemplateDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
